import { useState } from "react";
import { startSpoofing, stopSpoofing } from "../spoofingApiCalls";

export const useSpoofing = () => {
	const [spoofedUser, setSpoofedUser] = useState(null);

	const checkSpoofing = () => {
		setSpoofedUser(!!sessionStorage.getItem("authSpoofer"));
	};

	const handleStartSpoofingClick = async (selectedUser) => {
		try {
			const targetUsername = selectedUser.Email;
			const result = await startSpoofing(targetUsername);
			if (result.success) {
				window.location.reload();
			}
			setSpoofedUser(selectedUser);
		} catch (err) {
			console.log(`Error in handleStartSpoofingClick ${JSON.stringify(err)}`);
		}
		checkSpoofing();
	};

	const handleStopSpoofingClick = async () => {
		try {
			const result = await stopSpoofing();
			if (!result.success) {
				alert(result.error);
				return;
			}
			setSpoofedUser(null);
			window.location.reload();
		} catch (err) {
			console.log(`Error in handleStopSpoofing ${JSON.stringify(err)}`);
		}
		checkSpoofing();
	};

	return {
		spoofedUser,
		checkSpoofing,
		handleStartSpoofingClick,
		handleStopSpoofingClick,
		setSpoofedUser,
	};
};
